// extracted by mini-css-extract-plugin
export default {"Box":"OverviewHeader-module__Box--fFKf5","Box_1":"OverviewHeader-module__Box_1--zJpeS","PublishBanners":"OverviewHeader-module__PublishBanners--QtLjz"};